// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3xDJp","footer":"Form_footer__GSdZz"};